package app.nestbridge.app.usecase

import app.nestbridge.app.context.identity.UserContext
import app.nestbridge.app.context.identity.UserContextProvider
import me.tatarka.inject.annotations.Inject

@Inject
class SetUserContextUseCase(
    private val userContextProvider: UserContextProvider,
) {
    suspend operator fun invoke(context: UserContext?) {
        userContextProvider.set(context)
    }
}
